import React, { useEffect, useRef } from 'react';
// @ts-ignore
import WebGLFluid from './webgl-fluid';

export default function SmokeBackground() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    // ペール水色、ペール紫、グレーの色定義 (背景色#1A1C1Fに馴染むよう0.28〜0.35にスケール調整)
    const palette = [
      { r: 0.62 * 0.32, g: 0.76 * 0.32, b: 1 * 0.32 }, // #A0C4FF (ペール水色)
      { r: 0.8 * 0.32, g: 0.7 * 0.32, b: 0.85 * 0.32 }, // #CDB4DB (ペール紫)
      { r: 0.69 * 0.3, g: 0.69 * 0.3, b: 0.69 * 0.3 }, // #B0B0B0 (グレー)
    ];

    const animationsEnabled = localStorage.getItem('animationsEnabled') !== 'false';

    const gl = canvasRef.current.getContext('webgl') || canvasRef.current.getContext('experimental-webgl');
    if (!gl) {
      console.warn('WebGL is not supported in this environment.');
      return;
    }

    WebGLFluid(canvasRef.current, {
      PAUSED: !animationsEnabled,
      IMMEDIATE: true,
      TRIGGER: 'none',
      SIM_RESOLUTION: 256, // 解像度は標準に
      DYE_RESOLUTION: 1024,
      CAPTURE_RESOLUTION: 512,
      DENSITY_DISSIPATION: 0.0, // 消えずに残り続ける
      VELOCITY_DISSIPATION: 0.2, // 減衰を低くして、流体が長時間ゆっくりと動き回るようにする (0.2)
      PRESSURE: 0.8, // 圧力を少し高めにして、より滑らかに他の液滴と押し合い混ざり合うようにする (0.8)
      PRESSURE_ITERATIONS: 20,
      CURL: 35, // 渦の力を強めて、美しいマーブル状の渦巻きや筋を作り出す (35)
      SPLAT_COUNT: 15, // 初期に吹き出すスプラット数
      SPLAT_RADIUS: 1.5, // 2倍の広がり（1.2）よりさらに広め（1.5）に設定してダイナミックな広がりを演出
      SPLAT_FORCE: 250, // 初期吹き出しの力を半分の 250 に設定し、より緩やかで上品な速度にする
      SHADING: true, // 光沢のあるシェーディングを有効にしてガラス質感・透明感を出す
      COLORFUL: true,
      SPLAT_COLOR: palette,
      HOVER: false,
      BACK_COLOR: '#1A1C1F',
      TRANSPARENT: true,
      BLOOM: true, // 光の屈折感と深度を有効にする
      BLOOM_ITERATIONS: 8,
      BLOOM_RESOLUTION: 256,
      BLOOM_INTENSITY: 0.8,
      BLOOM_THRESHOLD: 0.6,
      BLOOM_SOFT_KNEE: 0.7,
      SUNRAYS: false,
      SUNRAYS_RESOLUTION: 196,
      SUNRAYS_WEIGHT: 1.0,
    });
  }, []);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          position: 'absolute',
          top: -100,
          left: -100,
          width: 'calc(100% + 200px)',
          height: 'calc(100% + 200px)',
          pointerEvents: 'none',
          opacity: 0.38, // 煙の濃度を程よく視認できる濃さにする
          filter: 'brightness(0.9)', // コントラストを外し、より滑らかで柔らかい煙の印象にする
          mixBlendMode: 'screen', // 背景色と綺麗になじませる
          willChange: 'transform', // GPU最適化
        }}
      />
    </div>
  );
}

